// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"1ec754ca","209":"664e29c4","478":"55acacbe","562":"2fd7dd47","922":"a65afe4f"}[chunkId] + ".chunk.js";
};